// state/campaigns.effects.ts
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CampaignsActions } from './actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { CampaignsService } from '../../services/campaigns/service';

@Injectable()
export class CampaignsEffects {
  private actions$ = inject(Actions);
  private svc = inject(CampaignsService);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CampaignsActions.load),
      switchMap(() =>
        this.svc.getAll().pipe(
          map((campaigns) => CampaignsActions.loadSuccess({ campaigns })),
          catchError((error) => of(CampaignsActions.loadFailure({ error })))
        )
      )
    )
  );
}
